export default __webpack_public_path__ + "static/media/dark-logo.73832335.png";